import React from "react";
import {generateArray} from "../../../utils/array-helper";
import {useServices} from "../../react-hooks/use-services.hook";
import {LineBetweenSlicesBox} from "./boxes/pegs/line-between-slices.box";
import {PegBox} from "./boxes/pegs/peg.box";

interface IWheelPegsProps {
    totalPegs: number;
    onPegRefCapture: (pegRef: HTMLDivElement | null, idx: number) => void;
}

export const WheelPegs: React.FC<IWheelPegsProps> = ({totalPegs, onPegRefCapture: onPegRefChange}) =>  {
    const services = useServices();
    return <div className="wheel-pegs" style={{position: "absolute", width: "100%", height: "100%"}}>
        {generateArray(totalPegs).map((idx) => (
            <React.Fragment key={idx}>
                <PegBox className="slice-line" pegIndex={idx} totalPegs={totalPegs} >
                    <LineBetweenSlicesBox />
                </PegBox>
                <PegBox className="peg" pegIndex={idx} totalPegs={totalPegs} >
                    <img
                        src={services.theme.currentTheme.assets.images.wheel_of_jackpotbet.gold_center_png.toString()}
                        alt=""
                        style={{width: "6px", display: "block", zIndex: 100}}
                        ref={(pegEl) => {
                            onPegRefChange(pegEl, idx);
                        }}
                    />
                </PegBox>
            </React.Fragment>
        ))}
    </div>
}